import React from 'react';
import { withRouter } from 'react-router-dom';
import { Level } from 'rbx';
import styled from 'styled-components';
import Can from '../../../utils/Can';
import { ACLSConsumer } from '../../../utils/aclsContext';

const Wrapper = styled.div`
  padding: 0rem 1rem;
  padding-bottom: 1rem;
`;

const Footer = ({
  handleUpdate,
  handleApprove,
  approvalLoading,
  placeUpdateLoading,
  approvalStatus,
  next,
  prev,
  activeTab,
  history,
  dirty,
  location,
}) => (
  <Wrapper>
    <Level>
      <Level.Item align="left">
        <Level.Item>
          <a onClick={() => history.goBack()} className="button is-light">
            <span>Cancel</span>
          </a>
        </Level.Item>
        {activeTab !== 0 && (
          <Level.Item>
            <button onClick={prev} className="button is-primary">
              <span>Prev Tab</span>
            </button>
          </Level.Item>
        )}
      </Level.Item>

      <Level.Item align="right">
        <ACLSConsumer>
          {({ apiActions, pageActions }) => (
            <Can
              action={`${
                location.pathname === '/place-approval-update'
                  ? 'update_place'
                  : 'update_place'
              }`}
              yes={() => (
                <Level.Item>
                  <button
                    className={`button is-primary ${approvalLoading &&
                      'is-loading'}`}
                    onClick={handleApprove}
                    disabled={approvalStatus === 'APPROVED'}
                  >
                    <span>Approve</span>
                  </button>
                </Level.Item>
              )}
              apiActions={apiActions}
              pageActions={pageActions}
            />
          )}
        </ACLSConsumer>

        <ACLSConsumer>
          {({ apiActions, pageActions }) => (
            <Can
              action={`${
                location.pathname === '/place-approval-update'
                  ? 'update_place'
                  : 'update_place'
              }`}
              yes={() => (
                <Level.Item>
                  <button
                    className={`button is-primary ${placeUpdateLoading &&
                      'is-loading'}`}
                    onClick={handleUpdate}
                    disabled={!dirty}
                  >
                    <span>Update</span>
                  </button>
                </Level.Item>
              )}
              apiActions={apiActions}
              pageActions={pageActions}
            />
          )}
        </ACLSConsumer>
        {activeTab !== 2 && (
          <Level.Item>
            <button onClick={next} className="button is-primary">
              <span>Next Tab</span>
            </button>
          </Level.Item>
        )}
      </Level.Item>
    </Level>
  </Wrapper>
);

export default withRouter(Footer);
